import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  paymentDetails: {
    defaultMessage: 'Payment Details',
    id: 'X9iK8P',
    description: 'Payment details section header text',
  },
  paymentDetailsSection: {
    defaultMessage: 'Payment Details Section',
    id: 'Nu94eq',
    description: 'Aria label for payment details section',
  },
  shippingCost: {
    defaultMessage: 'Shipping cost',
    id: 'g6kC+O',
    description: 'Shipping cost label',
  },
  taxes: {
    defaultMessage: 'Taxes',
    id: 'gZ27GS',
    description: 'Taxes label',
  },
  tariffs: {
    defaultMessage: 'Tariffs',
    id: 'iLVEqq',
    description: 'Tariffs label',
  },
});
